import React from "react";

import { SiteVisitReason } from "../../../../../components/wlrBroadband/SiteVisitReason";

export const SiteVisitReasonContainer = () => {
  return <SiteVisitReason />;
};
